import * as React from 'react';
import { useState, useEffect } from "react";
import Modal from "../../../component/Global/Modal";
import BOM from "@system/config/bom";
import alertic from 'src/assets/images/yellow-alert.png';
import { useBOMStore } from 'src/hooks/bom';
import System from 'src/helper/system';
import { useAxiosIndicatorCheck } from "../../../store/hook/useAxiosIndicatorCheck";
import { useDOMAttachToSystemStore } from 'src/hooks/domAttachToSystem';
import Constants from "src/support/Constants";

const CreatePartPopup = (props) => {
    const [__check] = useAxiosIndicatorCheck();
    const [status, SetStatus] = useState(false);
    const [partList, setPartList] = useState([]);
    const [partListError, setPartListError] = useState(false);
    const [{ CreatePartPopup }, {}, {}] = useDOMAttachToSystemStore();
    const [{ }, { get_all_bom_detail_by_bom_id_with_type_based_on_bom_tab_ui }, { create_part_list }] = useBOMStore();
    const { sourceOfBOM } = Constants;
    const bom_id = System.getParams().bomId
    const add_from = props?.data?.addFrom;
    useEffect(() => {
        if (CreatePartPopup) {
            SetStatus(true)
        }
    }, [CreatePartPopup]);
    const onHide = (action = true) => {
        SetStatus(false)
    };
    const part_list_text = (value = '') => {
        const item_separator = '\n';
        const item_tab_separator = '\t';
        const item_internal_data_separator = ',';
        let final_data = [];
        if (value.includes(item_separator) && value.includes(item_tab_separator)) {
            let list = value.split(item_separator);
            if (list && list.length > 0) {
                list.map((v) => {
                    if (v.includes(item_tab_separator)) {
                        let list_here = v.split(item_tab_separator);
                        if (list_here[0] !== undefined && list_here[0]) {
                            final_data.push({
                                partNumber: list_here[0].trim(),
                                quantity: (list_here[1] && parseInt(list_here[1].trim()) === '' ? null : parseInt(list_here[1].trim())),
                                LifeCycleRisk: '',
                                itemNumber: '',
                                erpItemNumber: ''
                            })
                        }
                    } else if (v.includes(item_internal_data_separator)) {
                        let list_here = v.split(item_internal_data_separator);
                        if (list_here[0] !== undefined && list_here[0]) {
                            final_data.push({
                                partNumber: list_here[0].trim(),
                                quantity: (list_here[1] && parseInt(list_here[1].trim()) === '' ? null : parseInt(list_here[1].trim())),
                                LifeCycleRisk: '',
                                itemNumber: '',
                                erpItemNumber: ''
                            })
                        }
                    } else {
                        final_data.push({
                            partNumber: v.trim(),
                            LifeCycleRisk: '',
                            itemNumber: '',
                            erpItemNumber: ''
                        })
                    }
                })
            }
        } else if (value.includes(item_separator)) {
            let list = value.split(item_separator);
            if (list && list.length > 0) {
                list.map((v) => {
                    if (v.includes(item_internal_data_separator)) {
                        let list_here = v.split(item_internal_data_separator);
                        if (list_here[0] !== undefined && list_here[0]) {
                            final_data.push({
                                partNumber: list_here[0].trim(),
                                quantity: (list_here[1] && parseInt(list_here[1].trim()) === '' ? null : parseInt(list_here[1].trim())),
                                LifeCycleRisk: '',
                                itemNumber: '',
                                erpItemNumber: ''
                            })
                        }
                    } else {
                        final_data.push({
                            partNumber: v.trim(),
                            LifeCycleRisk: '',
                            itemNumber: '',
                            erpItemNumber: ''
                        })
                    }
                })
            }
        } else if (value.includes(item_tab_separator)) {
            let list_here = value.split(item_tab_separator);
            if (list_here[0] !== undefined && list_here[0]) {
                final_data.push({
                    partNumber: list_here[0].trim(),
                    quantity: (list_here[1] && parseInt(list_here[1].trim()) === '' ? null : parseInt(list_here[1].trim())),
                    LifeCycleRisk: '',
                    itemNumber: '',
                    erpItemNumber: ''
                })
            }
        } else if (value.includes(item_internal_data_separator)) {
            let list_here = value.split(item_internal_data_separator);
            if (list_here[0] !== undefined && list_here[0]) {
                final_data.push({
                    partNumber: list_here[0].trim(),
                    quantity: (list_here[1] && parseInt(list_here[1].trim()) === '' ? null : parseInt(list_here[1].trim())),
                    LifeCycleRisk: '',
                    itemNumber: '',
                    erpItemNumber: ''
                })
            }
        } else {
            if (value !== undefined) {
                final_data.push({
                    partNumber: value.trim(),
                    LifeCycleRisk: '',
                    itemNumber: '',
                    erpItemNumber: ''
                })
            }
        }
        setPartList(final_data)
    };

    const onAddParts = async () => {
        if (bom_id !== undefined && bom_id !== '' && (partList === undefined || partList.length === 0)) {
            setPartListError(true)
        } else if (bom_id !== undefined && bom_id !== '') {
            let param = {}
            param.bomId = bom_id;
            param.partList = partList
            param.source = sourceOfBOM.PARTLIST;
            let create_part_lists = await create_part_list(param)
            if (create_part_lists.payload !== undefined &&
                create_part_lists.payload.data !== undefined) {
                await get_all_bom_detail_by_bom_id_with_type_based_on_bom_tab_ui(bom_id, true)
                onHide()
            }
        } else {
            let param = {}
            param.bomId = ''
            param.partList = partList;
            param.source = sourceOfBOM.PARTLIST;
            let create_part_lists = await create_part_list(param)
            if (create_part_lists.payload !== undefined &&
                create_part_lists.payload.data !== undefined) {
                window.location.href = BOM.getBomDetailByIdRouteURL(
                    create_part_lists.payload.data.bomId,
                    {
                        go: System.getParams().go,
                        addFrom:add_from
                    }
                );
            }
        }
    };

    return (
        <>
            <Modal show={status} onHide={() => {
                onHide()
            }}>
                <div className="avnet-modal avnet-modal-right">
                    <div className="avnet-modal-inner">
                        <button type="button" className="close py-2" data-dismiss="modal"
                            onClick={() => {
                                onHide()
                            }}>×
                        </button>
                        <div className="modal-header">
                            <h4 className="modal-title text-center"
                                id="myModalLabel">{CreatePartPopup && CreatePartPopup.data && CreatePartPopup.data.title}</h4>
                        </div>
                        <div className="modal-body">
                            {
                                partListError === true &&
                                <div className="alert alert-danger">
                                    <span> No data entered. Please add parts before you proceed to BOM. </span>
                                    <img
                                        className="ms-auto"
                                        src={alertic} />
                                </div>
                            }

                            <p className='mb-0 mt-1'><b>Copy and Paste or type in up to 100 part numbers using the following format:</b></p>
                            <p className="mb-0">PART # (COMMA) QUANTITY</p>
                            <p className="mb-0">EG.( 2N222,250 )</p>
                            <br></br>
                            <p className='mb-3'>Note: For the part numbers that includes a comma,
                            please copy & paste by using tab between part # and
                                quantity instead of a comma. </p>
                            <div className="form-group mb-4">
                                <textarea className="form-control" rows="5" id="comment"
                                    onChange={(e) => {
                                        part_list_text(e.target.value)
                                    }}
                                    placeholder="LM324, 250&#10;LM324ADG, 750&#10;BAV99">

                                </textarea>
                            </div>

                            <div className="text-center">
                                <button type="button" className="bs5 btn btn-secondary me-2 w120" data-dismiss="modal"
                                    onClick={() => {
                                        onHide()
                                    }}>Close
                                </button>
                                <button type="button" className="bs5 btn btn-primary w120"
                                    onClick={(e) => { __check(['BOM_OPERATION_API_CALL']).status ? e.preventDefault() : onAddParts() }}>
                                    {__check(['BOM_OPERATION_API_CALL']).status &&
                                        <>
                                            <i className="fa fa-spinner fa-spin" />
                                        </>
                                    }
                                    {!__check(['BOM_OPERATION_API_CALL']).status &&
                                        <>
                                            ADD PARTS
                                        </>
                                    }
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            </Modal>
        </>
    )
}

export default CreatePartPopup;